<div class="iframe-container" *ngIf="seccionActive">
    <iframe
      id="grafanaIframe"
      [src]="urlGrafana"
      frameborder="0"
      allow="same-origin"
    ></iframe>    
  </div>


